import { RECOVERY_STEP, type RecoveryStep } from '@src/features/customers/types';

export function nextRecoveryStep(state: {
  current: RecoveryStep;
  codeResent: boolean;
  fixEmail: boolean;
  hasRecoveryEmail: boolean;
  hasRecoveryCode: boolean;
}): RecoveryStep | null {
  const { current, codeResent, fixEmail, hasRecoveryEmail, hasRecoveryCode } = state;

  if (hasRecoveryCode && current === RECOVERY_STEP.VALID_CODE) return RECOVERY_STEP.PASSWORD_RECOVER;
  if (hasRecoveryEmail && current === RECOVERY_STEP.PASSWORD_RESET) return RECOVERY_STEP.VALID_CODE;
  if (fixEmail || !hasRecoveryEmail)
    return current === RECOVERY_STEP.PASSWORD_RESET ? null : RECOVERY_STEP.PASSWORD_RESET;
  if (codeResent) return current === RECOVERY_STEP.VALID_CODE ? null : RECOVERY_STEP.VALID_CODE;

  return null;
}
